/**
 * EF-SETTINGS-CONSOLIDATION-V1 (PHASE 2): Email Settings Router
 * 
 * SHADOW MODE: This component controls which email UI is displayed.
 * 
 * When USE_NEW_EMAIL_UI is false: Shows the old separate EmailSettingsPage
 * When USE_NEW_EMAIL_UI is true: Shows the new unified CompanyEmailPage (DEFAULT)
 * 
 * This allows safe rollout of the new UI without breaking existing functionality.
 * 
 * URL Parameters for testing:
 * - ?force_new=true  → Forces new UI
 * - ?force_old=true  → Forces old UI (for rollback)
 */

import React from "react";
import { useSearchParams } from "react-router-dom";

// Import both old and new components
import EmailSettingsPage from "./EmailSettingsPage";
import CompanyEmailPage from "./CompanyEmailPage";

// ============================================================================
// SHADOW MODE FLAG
// ============================================================================
// EF-SETTINGS-CONSOLIDATION-V1 (PHASE 4.5): Enabled new unified Email UI as default
// Old UI still accessible via ?force_old=true for rollback
const USE_NEW_EMAIL_UI = true;

// ============================================================================
// ROUTER COMPONENT
// ============================================================================
export default function EmailSettingsRouter() {
  const [searchParams] = useSearchParams();
  
  // Check for force flag in URL (for testing)
  // ?force_new=true or ?force_old=true
  const forceNew = searchParams.get("force_new") === "true";
  const forceOld = searchParams.get("force_old") === "true";
  
  // Determine which UI to show
  let showNewUI = USE_NEW_EMAIL_UI;
  
  if (forceNew) {
    showNewUI = true;
  } else if (forceOld) {
    showNewUI = false;
  }
  
  // Log which UI is being used (for debugging)
  if (process.env.NODE_ENV === "development") {
    console.log(`[EmailSettingsRouter] Flag: USE_NEW_EMAIL_UI=${USE_NEW_EMAIL_UI}, Showing: ${showNewUI ? "NEW" : "OLD"} UI`);
  }
  
  // Render the appropriate component
  if (showNewUI) {
    // Pass isBetaMode prop to show banner when accessed via force_new
    return <CompanyEmailPage isBetaMode={forceNew} />;
  }
  
  return <EmailSettingsPage />;
}

// Export the flag for use in other components
export { USE_NEW_EMAIL_UI };
